export const CART_TOGGLE = "CART_TOGGLE";
export const ADD_ITEM_TO_CART = "ADD_ITEM_TO_CART";
export const DELETE_CART_ITEM = "DELETE_CART_ITEM";
export const REMOVE_A_ITEM = "REMOVE_A_ITEM";
